import React from "react";
import { Card, ListGroup, ListGroupItem } from "react-bootstrap";
import { Link } from "react-router-dom";

const Product = ({ product }) => {
  return (
    <div className="product-container d-flex justify-content-center align-items-center">
      <Card style={{ width: "18rem", height: "670px" }}>
        <Card.Img variant="top" src={product.img} />
        <Card.Body>
          <Card.Title>
            {" "}
            <h6>{product.name}</h6>{" "}
          </Card.Title>
          <Card.Text>
            <small>{product.description.slice(0, 150)}...</small>{" "}
          </Card.Text>
        </Card.Body>
        <ListGroup className="list-group-flush">
          <ListGroupItem>
            In Stock: <strong>{product.quantity}</strong>
          </ListGroupItem>
          <ListGroupItem>
            Price : <strong>{product.price}</strong>{" "}
          </ListGroupItem>
          <ListGroupItem>
            Supplier: <em> {product.supplier}</em>{" "}
          </ListGroupItem>
        </ListGroup>
        <Card.Body>
          <Link
            to={`/manageProduct/${product._id}`}
            className="d-block btn btn-primary w-75 mx-auto"
          >
            Manage
          </Link>
        </Card.Body>
      </Card>
    </div>
  );
};

export default Product;
